import React from 'react';
import { useNavigate } from 'react-router-dom'; // Using useNavigate for navigation
import Navbar from '../components/Navbar'; // Adjust the path as needed
import '../styles/CAD.css';

const TechAdvisoryConsulting = () => {
    const navigate = useNavigate();

    // For demonstration, the Learn More buttons currently redirect to Google.
    // Replace this with your actual navigation logic or paths as needed.
    const handleNavigation = () => {
        navigate('/contact');
    };

    return (
        <>
            <Navbar />
            <div className="custom-app-development">
                <div className="content-box">
                    <header className="header">
                        <h1>Tech Advisory & Consulting</h1>
                        <p className="tagline">
                            Drive innovation with strategic technology guidance from our seasoned experts.
                        </p>
                    </header>
                    
                    <section className="introduction">
                        <p>
                            In today's fast-paced digital environment, a robust technology strategy is key to maintaining a competitive edge. Our Tech Advisory & Consulting services empower your organization with actionable insights and clear roadmaps that drive innovation and sustainable growth.
                        </p>
                    </section>
                    
                    <section className="why-choose-us">
                        <h2>Why Choose Our Advisory Services?</h2>
                        <p>
                            Our experienced consultants blend deep industry knowledge with forward-thinking strategies to help you unlock new opportunities, mitigate risks, and maximize your technology investments. We tailor our approach to meet your unique business challenges, ensuring a custom solution that drives results.
                        </p>
                    </section>
                    
                    <section className="tech-stack">
                        <h2>Our Approach & Methodology</h2>
                        <p>
                            We follow a structured process to deliver clear, actionable insights:
                        </p>
                        <ul>
                            <li><strong>Technology Assessment:</strong> In-depth analysis of your current IT landscape.</li>
                            <li><strong>Strategic Roadmapping:</strong> Crafting a long-term technology plan aligned with your business objectives.</li>
                            <li><strong>Risk & Opportunity Analysis:</strong> Identifying vulnerabilities and uncovering growth prospects.</li>
                            <li><strong>Implementation Support:</strong> Hands-on guidance through digital transformation.</li>
                        </ul>
                    </section>
                    
                    <section className="secure-practices">
                        <h2>Trusted & Transparent Guidance</h2>
                        <p>
                            We prioritize security, transparency, and measurable outcomes. Our advisory services not only provide strategic direction but also deliver practical implementation plans that ensure real business value.
                        </p>
                    </section>
                    
                    <section className="services">
                        <h2>Our Tech Advisory Offerings</h2>
                        <div className="service-container">
                            <div className="service-box">
                                <h3>IT Strategy Consulting</h3>
                                <p>
                                    Develop a comprehensive IT strategy that drives growth and aligns with your business vision.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Digital Transformation Advisory</h3>
                                <p>
                                    Leverage digital innovations to transform operations and boost overall efficiency.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Emerging Technology Consulting</h3>
                                <p>
                                    Stay ahead with insights on emerging technologies and tailor solutions for tomorrow's challenges.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Innovation Workshops</h3>
                                <p>
                                    Empower your team through hands-on workshops designed to foster creativity and accelerate technological innovation.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
};

export default TechAdvisoryConsulting;
